import { Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { conversationAssigneeUserId } from '../../../../core/src/lib/conversation-utils';
import { ConversationDetail } from '../../../../core/src/lib/interface/conversation.interface';

const ASSIGNED_TO_YOU_COLOR = 'var(--primary-color, #1976d2)';
const ASSIGNED_TO_TEAMMATE_COLOR = 'var(--secondary-text-color, #616161)';

interface ListAssignee {
  name: string;
  isYou: boolean;
}

/** The assignee's initial on a conversation list row; empty when unassigned or the assignee is unknown to the viewer. */
@Component({
  selector: 'inbox-conversation-assignee-avatar',
  templateUrl: './inbox-conversation-assignee-avatar.component.html',
  styleUrl: './inbox-conversation-assignee-avatar.component.scss',
  imports: [GalaxyAvatarModule, MatTooltipModule, TranslateModule],
})
export class InboxConversationAssigneeAvatarComponent {
  public readonly conversationDetail = input.required<ConversationDetail>();
  public readonly assigneeOverrides = input<ReadonlyMap<string, string>>(new Map());
  public readonly assigneeNames = input<ReadonlyMap<string, string>>(new Map());
  public readonly currentUserId = input('');

  protected readonly assignee = computed<ListAssignee | null>(() => {
    const detail = this.conversationDetail();
    const conversationId = detail.conversation?.conversationId ?? '';
    const assigneeUserId = this.assigneeOverrides().get(conversationId) ?? conversationAssigneeUserId(detail);
    const name = assigneeUserId ? this.assigneeNames().get(assigneeUserId) : undefined;
    if (!assigneeUserId || !name) {
      return null;
    }
    return { name, isYou: assigneeUserId === this.currentUserId() };
  });

  protected readonly backgroundColor = computed(() =>
    this.assignee()?.isYou ? ASSIGNED_TO_YOU_COLOR : ASSIGNED_TO_TEAMMATE_COLOR,
  );
}
